/**
 * Sprint M5.42 (30.07.2026) — Block A6.
 *
 * Reflexions-Vorschläge pro Fokustyp — „Darüber lohnt es sich nachzudenken".
 *
 * 2-3 Reflexions-Impulse je Fokustyp, aus denen der User beim Steckbrief-
 * Detail eigene Antworten ziehen kann. Nur für nicht-locked Steckbriefe
 * (eigener Fokustyp oder Pro-User) sichtbar.
 */
import React from "react";
import { HelpCircle } from "lucide-react";

const REFLEXIONEN = {
  eule: [
    "Wann hast du zuletzt eine Entscheidung nicht getroffen, weil du erst noch mehr verstehen wolltest? Was hat dich dazu bewogen?",
    "In welchen Situationen fällt es dir schwer, dich auf ein Bauchgefühl statt auf Argumente zu verlassen?",
    "Wenn jemand ohne Beleg von seiner Meinung überzeugt ist — was macht das mit dir und wie reagierst du?",
  ],
  biene: [
    "Wann macht dich ein fehlender Plan nervös, obwohl das Ergebnis eigentlich egal wäre?",
    "Wo hilft dein Bedürfnis nach Struktur anderen wirklich — und wo bremst es sie?",
    "Wie reagierst du, wenn jemand deine sorgfältige Vorarbeit umwirft, um schneller ans Ziel zu kommen?",
  ],
  katze: [
    "Wie erlebst du Grenzen, die andere dir setzen? Was löst das in dir aus?",
    "Wann hast du bewusst \u201enein\u201c gesagt, obwohl du wusstest, dass es unbequem wird? Wie ging es dir danach?",
    "In welchen Situationen fällt es dir schwer, die Wahlfreiheit anderer zu respektieren?",
  ],
  hund: [
    "Wann hast du zuletzt eigene Bedürfnisse zurückgestellt, um den Frieden zu wahren? Was ist mit deinen Bedürfnissen passiert?",
    "Woran erkennst du, dass du gerade zu viel Verantwortung für die Gefühle anderer trägst?",
    "Wie reagierst du, wenn jemand direkte Konfrontation sucht, obwohl du lieber schlichten würdest?",
  ],
};

export default function ReflexionsVorschlaege({ fokustyp }) {
  const impulse = REFLEXIONEN[fokustyp];
  if (!impulse || impulse.length === 0) return null;

  return (
    <section
      data-testid={`reflexions-vorschlaege-${fokustyp}`}
      className="rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-6 sm:p-8"
    >
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-blue-100 dark:bg-blue-900/40 text-[#4563BB] dark:text-blue-300 flex items-center justify-center">
          <HelpCircle className="w-5 h-5" />
        </div>
        <div className="flex-1">
          <p className="text-xs font-bold uppercase tracking-widest text-[#4563BB] dark:text-blue-300">
            Reflexions-Vorschläge
          </p>
          <h3 className="mt-1 text-lg sm:text-xl font-extrabold text-slate-900 dark:text-white">
            Darüber lohnt es sich nachzudenken
          </h3>
          <ol className="mt-4 space-y-3">
            {impulse.map((frage, i) => (
              <li
                key={i}
                data-testid={`reflexion-item-${fokustyp}-${i}`}
                className="flex gap-3 items-start"
              >
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-blue-100 dark:bg-blue-900/40 text-[#4563BB] dark:text-blue-300 font-bold text-xs flex items-center justify-center">
                  {i + 1}
                </span>
                <p className="text-sm text-slate-700 dark:text-slate-200 leading-relaxed">{frage}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
